import React, { useState, useRef } from 'react';
import Txt from '../../../inputs/textInput.js';
import { setResetPasswordForm } from '../../../../actions/user.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { clone } from '../../../../reducers/helper.js';
import { useDispatch, useSelector } from 'react-redux';
var passwordValidator = require('../../../../businessLogic/resetPasswordValidation');

const CenterPanelResetPasswordToken = (props) => {
  const dispatch = useDispatch();
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const resetPasswordFromRedux = useSelector((state) => state.usersReducer.resetPassword);
  const resetPasswordLocal = useRef(resetPasswordFromRedux);
  const [userEmail] = useState(resetPasswordFromRedux.resetPasswordToken.PersonEmail);
  const passwordChanged = (value) => {
    value = passwordValidator.removeInvalidChars(value);
    var resetPassword = clone(resetPasswordFromRedux);
    resetPassword.newPassword = value;
    resetPasswordLocal.current = resetPassword;
    dispatch(setResetPasswordForm(resetPassword));
  };
  const confirmPasswordChanged = (value) => {
    setConfirmNewPassword(value);
  };
  return (
    <div className={props.browser?.greaterThan?.medium ? 'ui form mrblll pdlxs' : 'ui form '}>
      <div>
        <span className=" ">{APP.LANGUAGE.ResetPassword.Title}</span> <br />
        <span className="mrts bold ">{userEmail}</span>
        <ValidMe
          validmefor="condition"
          group="resetPasswordTokenForm"
          getTemplatedError={(value) => {
            return passwordValidator.getErrorStyles(value || resetPasswordFromRedux.newPassword);
          }}
          condition={(value) => {
            //if all password strength conditions are good, returns true. else returns false.
            var np = value || resetPasswordFromRedux.newPassword;
            if (
              !passwordValidator.verifyPasswordLength(np) ||
              !passwordValidator.verifyPasswordStrengthLetter(np) ||
              !passwordValidator.verifyPasswordStrengthNumber(np) ||
              !passwordValidator.verifyPasswordStrengthSpecialCharacter(np)
            )
              return false;
            return true;
          }}
        >
          <Txt
            tabIndex="1"
            type="password"
            focusme="true"
            value={resetPasswordFromRedux.newPassword}
            placeholder={APP.LANGUAGE.ResetPassword.NewPasswordholder}
            titlePlaceholder={APP.LANGUAGE.ResetPassword.NewPasswordholder}
            noTitle
            onChange={passwordChanged}
          />
        </ValidMe>
        <ValidMe
          validmefor="condition"
          group="resetPasswordTokenForm"
          validmemessagecondition={APP.LANGUAGE.ResetPassword.ConfirmPasswordNotSame}
          condition={(value) => {
            return resetPasswordLocal.current.newPassword == value;
          }}
        >
          <Txt
            tabIndex="1"
            autoComplete="new-password"
            type="password"
            value={confirmNewPassword}
            placeholder={APP.LANGUAGE.ResetPassword.ResetConfirmNewPasswordholder}
            titlePlaceholder={APP.LANGUAGE.ResetPassword.ResetConfirmNewPasswordholder}
            noTitle
            onChange={confirmPasswordChanged}
          />
        </ValidMe>
      </div>
    </div>
  );
};

export default CenterPanelResetPasswordToken;
